import React from "react"
import CareersComponent from "./Careers"
import careersFactory from "./careers.factory"

export { default as CareersQuery } from "./careers.query"

export const Careers = props => {
  const { data } = props
  const componentProps = { ...props, ...careersFactory.transform(data) }
  return <CareersComponent {...componentProps} />
}
